export const ChoosePlanTemplateIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="27" viewBox="0 0 24 27" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5542 14.4062V10.6875C12.5542 9.80775 11.8822 9.09375 11.0542 9.09375V9.09375C10.2262 9.09375 9.55419 9.80775 9.55419 10.6875V12.2812V17.5938L8.65319 16.6364C8.04619 15.9915 7.06219 15.9915 6.45519 16.6364V16.6364C5.93119 17.1932 5.85019 18.0655 6.26119 18.72L8.96019 23.0221C9.33119 23.6139 9.95619 23.9688 10.6252 23.9688H15.9132C16.9222 23.9688 17.7722 23.1708 17.8982 22.1073L18.4402 17.4992C18.5732 16.3655 17.8392 15.3221 16.7782 15.1383L12.5542 14.4062Z"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.179 19.7186H20C21.105 19.7186 22 18.7677 22 17.5936V4.87549C22 3.70143 21.105 2.75049 20 2.75049H4C2.895 2.75049 2 3.70143 2 4.87549V17.5936C2 18.7677 2.895 19.7186 4 19.7186H6.888"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.77734 5.39605C4.77434 5.39605 4.77234 5.39818 4.77234 5.40137C4.77234 5.40455 4.77434 5.40668 4.77734 5.40668C4.78034 5.40668 4.78234 5.40455 4.78234 5.40137C4.78234 5.39818 4.78034 5.39605 4.77734 5.39605"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.32031 5.39605C7.31731 5.39605 7.31531 5.39818 7.31531 5.40137C7.31531 5.40455 7.31731 5.40668 7.32031 5.40668C7.32331 5.40668 7.32531 5.40455 7.32531 5.40137C7.32531 5.39818 7.32331 5.39605 7.32031 5.39605"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.85938 5.39605C9.85637 5.39605 9.85438 5.39818 9.85438 5.40137C9.85438 5.40455 9.85637 5.40668 9.85938 5.40668C9.86238 5.40668 9.86437 5.40455 9.86437 5.40137C9.86437 5.39818 9.86238 5.39605 9.85938 5.39605"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
